
import { DecimalConfig } from "@/models/dossier-configs/decimal-config";
import { StockIn } from "@/models/base";
import { DossierConfigService } from "@/services/dossier-config-service";
import { printHumanFloat, printLocalDate } from "@/utils/pretty-print";
import { AuthService } from "@/services";
import { MODULE } from "@/config/modules";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			decimalSettings: new DecimalConfig(),
			buttonActions: [
				{text: "Verwijder lijn", value: "remove"},
			]
		};
	},
	props: {
		isSelected: Boolean,
		row: Object as () => StockIn,
		rowIndex: {
			type: Number
		}
	},
	computed: {
		total(): string {
			let price = this.row.UnitBuyPrice;
			return printHumanFloat(price * this.row.Qty, this.decimalSettings.Buy);
		},
		hasModuleTraceability(): boolean {
			return AuthService.hasModule(MODULE.WERKEN_MET_TRACERING);
		},
		descriptionWidth(): string {
			return this.hasModuleTraceability ? "calc(100% - 840px)" : "calc(100% - 560px)";
		},
		formattedTrackingValidUntil(): string {
			if (!this.row.TrackingNumberValidUntil) return "";
			return printLocalDate(this.row.TrackingNumberValidUntil);
		}
	},
	methods: {
		onEdit() {
			this.$emit("edit");
		},
		selectItem(row: StockIn) {
			this.$emit("select", row);
		},
		onRemove() {
			this.$emit("remove");
		},
		trigger(value: string) {
			this.$emit(value);
		},

	},
	async mounted() {
		this.decimalSettings = await DossierConfigService.getDecimalSettings();
	},
	i18nEx: {
		componentPrefix: "components.stock"
	}
});
